import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRefreshOnFocus } from '@24i/nxg-sdk-smartott-shared/src/hooks/useRefreshOnFocus';
import {
    onAnalytics as originalAnalytics,
    ANALYTICS_TRIGGERS,
} from '@24i/nxg-sdk-smartott-shared/src/analytics';
import { useSessionId } from '@24i/nxg-sdk-smartott-shared/src/analytics/hooks/useSessionId';
import { useCampaignAnalytics } from '@24i/nxg-sdk-smartott-shared/src/analytics/hooks/useCampaign';
import { useEnrichedAnalytics } from '@24i/nxg-sdk-smartott-shared/src/analytics/hooks/useEnrichedAnalytics';
import { useOnMaybeLaterPress } from '../../../hooks/subscriptions';
import useAvailableSubscriptionsQuery from '../../../hooks/query/subscriptions/useAvailableSubscriptions';
import { AddSubscriptionViewProps } from '../View/types';

const useViewModel = (): AddSubscriptionViewProps => {
    const { onMaybeLaterPress, isLoading: isLoadingOnMaybeLater } = useOnMaybeLaterPress();

    const { data, isLoading, refetch } = useAvailableSubscriptionsQuery();

    useRefreshOnFocus(refetch);
    const { t } = useTranslation(['sott']);
    const { sessionId } = useSessionId();
    const { campaignUrl, campaignCookie } = useCampaignAnalytics();
    const onAnalytics = useEnrichedAnalytics(originalAnalytics);

    useEffect(() => {
        if (data) {
            onAnalytics(ANALYTICS_TRIGGERS.SCENE_VIEW, {
                screen: t('analytics.documentTitle.purchase.step3'),
                sessionId,
                campaignUrl,
                campaignCookie,
            });
        }
    }, [data]);

    return {
        isLoading: isLoading || isLoadingOnMaybeLater,
        availableSubscriptions: data?.subscriptions,
        onMaybeLaterPress,
    };
};

export { useViewModel };
